import { connect } from 'react-redux';
import UserBanner from '../components/UserBanner';

export default connect(
  ({user}) => ({name: user.name, avatar: user.avatar, company: user.company})
)(UserBanner);
